

export const frontMatter = {
	sidebar_position: 8
};
export const contentTitle = 'Простая граматыка';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-be-docusaurus-plugin-content-docs-current-learn-simple-grammar-index-md-c1b.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, DocCardList} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!DocCardList) _missingMdxReference("DocCardList", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "простая-граматыка",
        children: "Простая граматыка"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Спрошчаная граматыка, або ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), ", - гэта вельмі спрошчаная форма міжславянскай мовы, якая дазваляе неславянам выказвацца на вельмі простым узроўні, наведваючы славянскія краіны або падтрымліваючы кантакты са славянамі праз Інтэрнэт. Граматыка абмежаваная мінімумам, а формы, якія не з'яўляюцца строга неабходнымі, не выкарыстоўваюцца наогул. Паколькі ў ім няма нічога, што нельга знайсці ў славянскіх мовах, вынік не будзе выглядаць або гучаць занадта нязграбна для носьбітаў славянскай мовы, а хутчэй нагадае ім мову, якой карыстаюцца маленькія дзеці."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " таксама можна выкарыстоўваць як першы крок у працэсе вывучэння «сапраўднай» міжславянскай мовы. Ён быў пабудаваны такім чынам, каб яго можна было паступова пашыраць новымі часткамі, якія сустракаюцца ў больш складаных версіях. Такім чынам, мы вылучаем тры розныя ўзроўні, кожны з якіх дадае новыя элементы, якія набліжаюць ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " да міжславянскага:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Узровень 1"
        }), " – самы просты ўзровень: без роду, без склонаў, толькі адзіночны/множны лік, адзін канчатак дзеяслова на час"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Узровень 2"
        }), " – увядзенне ў гендэр, простая мадэль для спражэння дзеясловаў (рэчы, якія можна знайсці ва ўсіх славянскіх мовах)"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Працоўны загаловак ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " — гэта слова для «славянскага эсперанта». Гэтая назва, хоць і крыху насмешлівая, адносіцца да прастаты ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), ": яна не мае ні роду, ні падежаў, ні аспекту, мала спалучэнняў і нерэгулярнасці. Тым не менш, на гэтым падабенства з эсперанта заканчваецца, таму што сродкі спрашчэння ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " насамрэч значна больш падобныя да тых, што выкарыстоўваюцца ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Interlingua"
      }), "."]
    }), "\n", _jsx(DocCardList, {}), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

